import { render, staticRenderFns } from "./item-title.vue?vue&type=template&id=6ac14e43&scoped=true&"
import script from "./item-title.vue?vue&type=script&lang=js&"
export * from "./item-title.vue?vue&type=script&lang=js&"
import style0 from "./item-title.vue?vue&type=style&index=0&id=6ac14e43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac14e43",
  null
  
)

export default component.exports